




















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Button, Checkbox, FormItem, Input, Option, Select } from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// sections
import DeliverySection from '@/components/documents/sections/DeliveryInformation.vue';
import FreightDeliverySection from '@/components/documents/sections/FreightDeliveryInformation.vue';
import HeaderSection from '@/components/documents/sections/Header.vue';
import RequestSection from '@/components/documents/sections/RequestInformation.vue';
import ShipperSection from '@/components/documents/sections/Shipper.vue';
import TransportExportSection from '@/components/documents/sections/TransportInformationExport.vue';

// Options
import { axleTypeOptions } from '@/constants/axleTypeOptions';
import { containerSizeOptions } from '@/constants/containerSizeOptions';
import { truckTypeOptions } from '@/constants/truckOptions';

// types
import {
  DelegatedStepsEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  ShipmentDocumentFields_shipment,
  TaxTypeEnumBase,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    DeliverySection,
    FreightDeliverySection,
    HeaderSection,
    RequestSection,
    ShipperSection,
    TransportExportSection,
    UtcDatePicker,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class LandTransportationExport extends Vue {
  @Prop() document!: ShipmentDocumentFields;
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;

  formInput: ShipmentDocumentDataInput = {};

  // select options
  readonly axleTypeOptions = axleTypeOptions();
  readonly containerSizeOptions = containerSizeOptions();
  readonly truckTypeOptions = truckTypeOptions();

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;
  private readonly seaTransportation = [
    TransportationCargoTypeEnum.FCL,
    TransportationCargoTypeEnum.LCL
  ];

  created() {
    this.setFormInput();
  }

  @Watch('document')
  setFormInput() {
    this.formInput = {
      // IMPORTANT re send readonly data
      transportCargoType: this.document.data?.transportCargoType,
      shipmentCustomerRole: this.document.data?.shipmentCustomerRole,
      shipmentReference: this.document.data?.shipmentReference,
      transportationType: this.document.data?.transportationType,
      // END IMPORTANT
      // Header information
      assignedOperator: this.document.data?.assignedOperator,
      issuanceDate: this.document.data?.issuanceDate,
      // Shipper information
      customerName: this.document.data?.customerName,
      // Collection information
      truckType: this.document.data?.truckType,
      collectionPreferredDatetime: this.document.data?.collectionPreferredDatetime,
      collectionName: this.document.data?.collectionName,
      collectionAddress: this.document.data?.collectionAddress,
      collectionContact: this.document.data?.collectionContact,
      collectionPhone: this.document.data?.collectionPhone,
      containerNumbers: this.document.data?.containerNumbers.length
        ? [...this.document.data?.containerNumbers]
        : [{ containerNumber: null, sealNumber: null, containerType: null }],
      truckChassisType: this.document.data?.truckChassisType,
      weightCalibration: this.document.data?.weightCalibration || false,
      preCooling: this.document.data?.preCooling || false,
      presetTemperature: this.document.data?.presetTemperature,
      motorGenerator: this.document.data?.motorGenerator || false,
      ventilation: this.document.data?.ventilation,
      pickupRemarks: this.document.data?.pickupRemarks,
      // -----Freight information -----
      descriptionOfGoods: this.document.data?.descriptionOfGoods,
      packagingQuantity: this.document.data?.packagingQuantity,
      packaging: this.document.data?.packaging,
      grossWeight: this.document.data?.grossWeight,
      grossVolume: this.document.data?.grossVolume,
      dangerous: this.document.data?.dangerous || false,
      requiresWarehouseWork: this.document.data?.requiresWarehouseWork,
      // ----- TransportInformation section ----
      airCarrier: this.document.data?.airCarrier,
      seaCarrier: this.document.data?.seaCarrier,
      bookingNumber: this.document.data?.bookingNumber,
      vesselName: this.document.data?.vesselName,
      masterBlNumber: this.document.data?.masterBlNumber,
      houseBlNumber: this.document.data?.houseBlNumber,
      flightNumber: this.document.data?.flightNumber,
      consolidator: this.document.data?.consolidator,
      cyCfsCutDate: this.document.data?.cyCfsCutDate,
      voyageNumber: this.document.data?.voyageNumber,
      // ----- DeliveryInformation section ----
      deliveryRemarks: this.document.data?.deliveryRemarks,
      freightDeliveryAddress: this.document.data?.freightDeliveryAddress,
      freightDeliveryContact: this.document.data?.freightDeliveryContact,
      // ----- RequestInformation section -----
      attachedDocuments: this.document.data?.attachedDocuments ? [...this.document.data?.attachedDocuments] : [],
      arrangementRemarks: this.document.data?.arrangementRemarks,
      delegatedSteps: this.document.data?.delegatedSteps ? [...this.document.data?.delegatedSteps] : []
    };
  }
}
